import { Pipe, PipeTransform } from '@angular/core';

import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { sprintf } from '@shared/utils/string/string-format';

const errorMessageMap: Map<string, string> = new Map([
	['required', 'Pflichtfeld'],
	['email', 'Keine gültige Email-Adresse'],
	['minlength', 'Mindestens %d Zeichen'],
	['uniqueFieldName', 'Der Feldname wird bereits benutzt'],
	['pattern', 'Ungültiges Format'],
	['uniqueFieldName', 'Der Feldname wird bereits benutzt'],
	['json', 'Kein valides JSON-Schema: %s'],
	['max', 'Wert darf nicht größer als %s sein'],
	['min', 'Wert darf nicht kleiner als %s sein'],
	['cronNotFilled', 'Mindestens eines der beiden Felder muss ausgefüllt sein'],
	['identifierMissing', 'Mindestens einen Identifier auswählen'],
	['marginRuleNoZeroPrice', 'Es muss mindestens eine Margenregel mit Preisgrenze 0 existieren'],
	['duplicateMinimumPrices', 'Preisgrenzen dürfen nicht mehrfach vergeben werden'],
	['bothAmountAndPercentAreZero', 'Marge % und Marge € dürfen nicht beide 0 sein'],
]);


@Pipe({
    name: 'inputErrorMessage',
    standalone: false
})
export class InputErrorMessagePipe implements PipeTransform {
	// Value is passed in to detect changes in pipe (control won't change, so no change-detection)
	transform(value: any, control: UntypedFormControl | AbstractControl | null): any {
		if (!control) {
			return '';
		}
		return this.getErrorMessage(control as UntypedFormControl);
	}

	private getErrorMessage(control: UntypedFormControl): string | undefined {
		const keys = errorMessageMap.keys();
		for (const key of keys) {
			if (!control.hasError(key)) {
				continue;
			}

			const error = control.getError(key);
			if (key === 'minlength') {
				return this.getParsedErrorMessage(key, error.requiredLength);
			}
			if (key === 'max') {
				return this.getParsedErrorMessage(key, error.max);
			}

			if (key === 'min') {
				return this.getParsedErrorMessage(key, error.min);
			}

			if (key === 'json') {
				return this.getJSONErrorMessage(control, key);
			}
			return errorMessageMap.get(key);
		}
		return '';
	}

	// Net sehr erweiterbar ¯\_(ツ)_/¯
	private getParsedErrorMessage(key: string, messageValue: any): string {
		const message = errorMessageMap.get(key);
		const result = sprintf(message || '', messageValue);
		if (result.error) {
			return '';
		}
		return result.replaced;
	}

	private getJSONErrorMessage(control: UntypedFormControl, key: string): string {
		const error = control.getError(key);
		const message = errorMessageMap.get(key);

		const result = sprintf(message || '', error.errorMessage);
		if (result.error) {
			return '';
		}
		return result.replaced;
	}
}
